var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._b({staticClass:"d-inline-flex rounded-3 justify-content-center align-items-center"},'span',_vm.vBindColor,false),[_c('font-awesome-icon',_vm._b({},'font-awesome-icon',_vm.vBindIcon,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }